import React from "react";
import { HourMapping } from "../../configuration/createPackageFormConfigs";
import RescuePackageLogo from "../../assets/images/rescue_package.svg";
export default function RecoveryInsuranceTile({detailsItem}) {
  const {package_name,package_price,maximum_booking_allowed,package_duration,package_duration_unit,package_auto_renew,services}=detailsItem
  return (
    <>
      <div class="head">
        <img src={RescuePackageLogo} alt="" class="mr-8" />
        <p>
          <span>{package_name}</span>
          {package_price.slice(0, 1) != 0 && (
            <span>${Math.abs(package_price)}</span>
          )}
        </p>
        <ul class="tabsList">
        <li>
            {maximum_booking_allowed}{" "}
            services
          </li>
          <li>
            {package_duration && package_duration}
            {HourMapping?.[package_duration_unit]}
            {package_duration > 1 && "s"}
            &nbsp;validity
          </li>
        </ul>
      </div>
      <div class="dataTable">
        <div>
        {services&&services?.length>"0"&&services.map((service)=>{
            return(<>
            <div class="col" key={service.service_id}>
            <div class="colItem">{service?.service_name}</div>
            <div class="colItem">{service?.service_admin_note}</div>
          </div>
          
            </>)
          })}
          <div class="col">
            <div class="colItem">Auto renew</div>
            <div class="colItem">{package_auto_renew ==="1"? "Yes" : "No"}</div>
          </div>
        </div>
      </div>
    </>
  );
}
